export const VUEX_ANNOUNCEMENTS_FETCH = 'VUEX_ANNOUNCEMENTS_FETCH'
export const VUEX_ANNOUNCEMENTS_FETCH_SUCCESS = 'VUEX_ANNOUNCEMENTS_FETCH_SUCCESS'

export const VUEX_ANNOUNCEMENTS_DELETE = 'VUEX_ANNOUNCEMENTS_DELETE'
export const VUEX_ANNOUNCEMENTS_DELETE_SUCCESS = 'VUEX_ANNOUNCEMENTS_DELETE_SUCCESS'

export const VUEX_ANNOUNCEMENTS_UPDATE = 'VUEX_ANNOUNCEMENTS_UPDATE'
export const VUEX_ANNOUNCEMENTS_UPDATE_SUCCESS = 'VUEX_ANNOUNCEMENTS_UPDATE_SUCCESS'
